import Scriba from 'react-scriba';

export class DataRelance {

    static _chargementRelances = (filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex) => {
        const objet = { filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex };
        const url = "api/Liste/ListeDesRelances";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementRelance = (idRelance) => {
        const objet = { idRelance };
        const url = "api/Fiche/FicheRelance";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementRelance = (relance) => {
        const url = "api/MAJDonnees/EnregistrementRelance";
        const paramPost = Scriba.fetch().createParameterPost(relance);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionRelance = (idRelance) => {
        const objet = { idRelance };
        const url = "api/MAJDonnees/SuppressionRelance";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onPublipostageRelance = (idRelance, rowGuid) => {
        const url = "api/Download/PubliposterRelance";
        const paramPost = Scriba.fetch().createParameterPost({ idRelance, rowGuid });
        return fetch(url, paramPost).then(response => response.json());
    };

}
